export default __webpack_public_path__ + "static/media/spinner.3c541d2b.svg";